import qs from 'qs';
import { useResource } from 'react-resource-router';

import { useParams } from 'src/router/hooks';
import { workspaceNavigationResource } from 'src/sections/workspace/workspace-navigation-resource';

type WorkspaceNavActionUrls = {
  createProjectUrl?: string;
  createRepoUrl?: string;
  importRepoUrl?: string;
};

/** Returns actions user has permission to take. If the BE does not include the
 * action in the links object (data.links), it means user is not authorized to take that action
 */
export const useWorkspaceNavActionUrls = (): WorkspaceNavActionUrls => {
  const { data, error, loading } = useResource(workspaceNavigationResource);
  const { projectKey } = useParams<{
    projectKey: string;
  }>();

  if (!data || error || loading) {
    return {};
  }

  const { links } = data;
  // add the project key as a query param if user is currently
  // in the context of a specific project
  const projectQuery = qs.stringify(
    { project: projectKey },
    {
      skipNulls: true,
      addQueryPrefix: true,
    }
  );

  return {
    createProjectUrl: links?.create_project?.href,
    createRepoUrl:
      links?.create_repository?.href &&
      `${links?.create_repository?.href}${projectQuery}`,
    importRepoUrl:
      links?.import_repository?.href &&
      `${links?.import_repository?.href}${projectQuery}`,
  };
};
